import { handleResponse, handleError, MyAxios } from '@services/SettingAxios';
import { ServiceCookies } from '@services/ServiceCookies';
import { wrapperFetchCheckedValidateToken } from '@sharedHelpers/wrapperFetchCheckedValidateToken';
import { consentsType } from './api.dto';

export const fetchUpdateSettingAwareness = async (query: consentsType): Promise<[]> => {
  return await wrapperFetchCheckedValidateToken(async () => {
    try {
      const response = await MyAxios.post('api/user/profile/consents/update', query, {
        headers: {
          [ServiceCookies.JWT_HEADER]: ServiceCookies.jwtAccess,
        },
      });
      return handleResponse(response);
    } catch (error) {
      handleError(error);
      throw error;
    }
  });
};
